import { createApiClient } from '../codegen/auth-proxy-api';

export { schemas as authProxySchemas } from '../codegen/auth-proxy-api';

// The auth proxy URL is required: every app's next.config.js calls
// assertAuthProxyUrl (../auth-proxy-url.cjs) and fails next build/next dev
// before this module is ever reached if it is unset. A bundle built without
// next.config.js (e.g. the Storybooks) gets the same localhost fallback as
// @verifime/address-api-definition, because Zodios rejects an empty base
// url at construction. Next inlines only this exact
// `process.env.NEXT_PUBLIC_AUTH_PROXY_URL` member expression at build time,
// so it is read directly here rather than through an indirect lookup.
export const authProxyApi = createApiClient(
  process.env.NEXT_PUBLIC_AUTH_PROXY_URL || 'http://localhost:8080',
);
